var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "inline-block",
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "13",
        height: "8",
        viewbox: "0 0 13 8"
      }
    },
    [
      _c("path", {
        staticClass: "stroke-current",
        attrs: {
          fill: "none",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-miterlimit": "50",
          d: "M1 1v0l5.5 6v0L12 1v0"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }